import { Injectable } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ScaiService {

    appData: any;

    constructor(
        private httpClient: HttpClient,
        appService: AppService, 
    ) {
        this.appData = appService.settings;
    }

    getScaiReference(serviceRef: string, originId: string): Observable<any> {
        return this.httpClient.get(
            `${this.appData.webApi}/scai/scaiReferences/search/findByServiceRefAndOriginId/${serviceRef}/${originId}`);
    }

    completeActivity(serviceRef: string, originId: string, result: string, errorDescription: string, username: string): Observable<any>{

        return this.httpClient.patch(
            `${this.appData.webApi}/scai/custom/completeActivity`, 
            {serviceRef, originId, result, errorDescription, username});
    }

}
